import styled from '@emotion/styled';
import { ClassAttributes, createElement, ReactNode } from 'react';

import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import DummyContent from '../../primitive/DummyContent';

interface Props {
  className?: string;
  children: ReactNode;
}

const DummySection = ({ className, children }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <Title size="h6" length={66} />

    <Fields>{children}</Fields>
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['1fr'],
    rows: ['auto', '1fr'],
    areas: [['section_title'], ['fields']],
  }),
);

const Title = styled(DummyContent)(gridLayoutItem('section_title'), { marginBottom: SPACING_UNIT * 3 });

const Fields = styled('div')(gridLayoutItem('fields'), flexibleLayoutContainer({ direction: 'column' }), {
  '& > *': {
    marginBottom: SPACING_UNIT * 5,
  },
  '& > *:last-child': {
    marginBottom: 0,
  },
});

export default DummySection;
